import React from 'react'
import PropTypes from 'prop-types'
import { compose, withApollo } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import Typography from '@material-ui/core/Typography'
import { withSnackbar } from 'notistack'
import PickLocation from '../../components/PickLocation'
import LocationList from '../../components/LocationList'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import {
  createLocation,
  deleteLocation,
  fetchLocationByHero,
  updateLocation
} from '../../stores/location'
import { Row } from 'antd'

export const HeroLocation = ({ hero, heroConfig }) => {
  const dispatch = useDispatch()
  const { locationList } = useSelector((state) => state.location)

  async function fetchData() {
    await dispatch(fetchLocationByHero(hero.id))
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  const handleSetNewLocations = async (location) => {
    const data = {
      address: location.address,
      heroId: hero.id,
      image: null,
      lat: location.lat,
      lng: location.lng,
      name: '',
      radius: location.radius
    }
    await dispatch(createLocation(data))
    await dispatch(fetchLocationByHero(hero.id))
  }

  const handleSetUpdateLocations = async (location) => {
    const data = {
      address: location.address,
      heroId: hero.id,
      id: location.id,
      image: null,
      lat: location.lat,
      lng: location.lng,
      name: '',
      radius: location.radius
    }
    await dispatch(updateLocation(data))
    await dispatch(fetchLocationByHero(hero.id))
  }

  const handleSetDeleteLocations = async (id) => {
    await dispatch(deleteLocation(id))
    await dispatch(fetchLocationByHero(hero.id))
  }

  const getLocationCount = () => {
    if (hero.configByHero) {
      return hero.maxLocation
    } else {
      return heroConfig.locationCount
    }
  }

  return (
    <React.Fragment>
      {heroConfig && (
        <div>
          {locationList.length < getLocationCount() && (
            <div>
              <Row justify="center">
                <PickLocation
                  heroConfig={heroConfig}
                  setLocation={handleSetNewLocations}
                />
              </Row>
              <Row justify="center">
                <Typography align="center">
                  เพิ่มสถานที่ตั้งเพื่อให้ผู้อื่นเข้าถึง
                </Typography>
              </Row>
            </div>
          )}
          <LocationList
            locations={locationList}
            setUpdateLocations={handleSetUpdateLocations}
            setDeleteLocations={handleSetDeleteLocations}
          />
        </div>
      )}
    </React.Fragment>
  )
}

HeroLocation.propTypes = {
  hero: PropTypes.object.isRequired,
  heroConfig: PropTypes.object.isRequired
}

export default compose(withRouter, withApollo, withSnackbar)(HeroLocation)



// WEBPACK FOOTER //
// ./src/components/HeroLocation/index.js